import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home/home';
import AboutUs from './pages/home/aboutUs';
import Navbar from './pages/components/navbar';
import Footer from './pages/components/footer';
import Contact from './pages/home/contact';
import Projects from './pages/home/projects';
import Service from './pages/home/service';
import Brochure from './pages/components/Brochure';
import BrochurePage from './pages/components/BrouchurePage';
import ServiceDetails from './pages/components/serviceDetails';

function App() {
  return (
    <Router>
      <div className="App">

        <Navbar />


        <Routes>
          {/* Redirect "/" to "/home" */}
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contactUs" element={<Contact />} />
          <Route path="/products" element={<Projects />} />
          <Route path="/services" element={<Service />} />
          <Route path="/services/:id" element={<ServiceDetails />} />
          <Route path="/brochures" element={<BrochurePage />} />
          {/* Redirect all unmatched routes to "/home" */}
          <Route path="*" element={<Navigate to="/home" />} />
        </Routes>

        <Footer />

      </div>
    </Router>
  );
}

export default App;
